import React, { useEffect } from 'react';
import { Tooltip } from '@reach/tooltip';
import '@reach/tooltip/styles.css';
import tw from 'twin.macro';
import clsx from 'clsx';
import { getZIndex } from '@teetsh/app/src/components/Dialog';

interface Props {
  label: any;
  children: any;
  disabled?: boolean;
  className?: string;
  zIndex?: '10' | '20' | '30' | '50';
  delay?: number; // nouvelle prop
}

export default function Tooltip2(props: Props) {
  const {
    label,
    children,
    disabled,
    className,
    zIndex = '50',
    delay = 500, // valeur par défaut
  } = props;

  const [showTooltip, setShowTooltip] = React.useState<boolean>(false);
  const timeoutRef = React.useRef<NodeJS.Timeout>();

  const handleMouseEnter = () => {
    timeoutRef.current = setTimeout(() => {
      setShowTooltip(true);
    }, delay);
  };

  const handleMouseLeave = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setShowTooltip(false);
  };

  const handleMouseDown = () => {
    // handle weird click behavior which makes the tooltip stick (if you click while the tooltip is open and you exit very fast)
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setShowTooltip(false);
  };

  useEffect(
    () => () => {
      // cleanup on unmount to make sure no tooltip persists
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    },
    [],
  );

  if (disabled) {
    return children;
  }

  const style = tw`bg-white rounded-lg text-sm p-2`;

  return (
    <Tooltip
      style={{ ...style, ...getZIndex[zIndex] }}
      label={label}
      // @ts-ignore
      isVisible={showTooltip}
    >
      <div
        tw="inline-block"
        className={clsx(className, 'tsh-tooltip')}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onMouseDown={handleMouseDown}
      >
        {children}
      </div>
    </Tooltip>
  );
}
